export const PROGRAM_CARDS_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_course_id: "",
    meta_brochure_url: "",
    meta_slug: "",
    meta_url: "",
    meta_thumbnail_image: "",
    meta_thumbnail_image_alt: "Course thumbnail",
    meta_short_course_name: "MBA",
    meta_short_course_name_text_color: "#000000",
    meta_full_course_name: "Master of Business Administration",
    meta_course_name_text_color: "#000000",
    meta_subtext: "Transform your career with our flagship program",
    meta_subtext_color: "#666666",
    meta_enroll_icon: "",
    meta_enroll_icon_alt: "",
    meta_enroll_text: "500+ Enrolled",
    meta_enroll_text_color: "#000000",
    meta_money_icon: "",
    meta_money_icon_alt: "",
    meta_money_text: "₹5 Lakhs",
    meta_money_text_color: "#000000",
    meta_brochure_icon: "",
    meta_brochure_icon_alt: "",
    meta_brochure_text: "Download Brochure",
    meta_brochure_text_color: "#000000",
    meta_brochure_button_background_color: "#ffffff",
    meta_enable_brochure: true,
    meta_cta_button_text: "Apply Now",
    meta_cta_button_text_color: "#ffffff",
    meta_cta_button_background_color: "#BE2330",
    meta_cta_button_icon: "",
    meta_cta_button_icon_alt: "",
    meta_cta_mobile_text_color: "#ffffff",
    meta_cta_mobile_background_color: "#BE2330",
    meta_cta_mobile_icon: "",
    meta_cta_mobile_icon_alt: "",
    meta_priority: 1,
    meta_status: true,
  },

  PROGRAM_CARDS_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "Our Programs",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title (e.g., Our Programs)",
      required: false,
      defaultValue: "Our Programs",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "card_background_color",
      label: "Card Background Color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter card background color (e.g., #ffffff)",
      required: false,
      defaultValue: "#ffffff",
    },
    {
      fieldName: "load_more_text",
      label: "Load More Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Load More Text (e.g., Load More Programs)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "load_more_desktop_icon",
      label: "Load More Desktop Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Load More Desktop Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "load_more_desktop_icon_alt",
      label: "Load More Desktop Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Load More Desktop Icon Alt Text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "load_more_mobile_icon",
      label: "Load More Mobile Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Load More Mobile Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "load_more_mobile_icon_alt",
      label: "Load More Mobile Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Load More Mobile Icon Alt Text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "load_more_desktop_text_color",
      label: "Load More Desktop Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter load more desktop text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "load_more_mobile_text_color",
      label: "Load More Mobile Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter load more mobile text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    // {
    //   fieldName: "load_more_desktop_background_color",
    //   label: "Load More Desktop Background Color",
    //   value: "#ffffff",
    //   valueType: "string",
    //   filedType: "COLOR",
    //   placeholder: "Enter load more desktop background color (e.g., #ffffff)",
    //   required: false,
    //   defaultValue: "#ffffff",
    // },
    {
      fieldName: "load_more_mobile_background_color",
      label: "Load More Mobile Background Color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter load more mobile background color (e.g., #ffffff)",
      required: false,
      defaultValue: "#ffffff",
    },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Program Cards Section",
      defaultValue: false,
    }
  ],

  METADATA_FIELDS: [
    {
      header: "Course",
      fieldName: "meta_course_id",
      value: "",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Course",
      options: [], // Will be populated dynamically from parent
      linkedField: "meta_brochure_url", // Auto-populate this field (hidden)
      linkedValueKey: "brochure", // Use brochure value from selected course
      dynamicOptions: "courses", // Flag to indicate this needs dynamic options
    },
    {
      header: "Slug",
      fieldName: "meta_slug",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Slug (e.g., mba-program)",
    },
    {
      header: "URL",
      fieldName: "meta_url",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter URL (e.g., /programs/mba)",
    },
    {
      header: "Thumbnail Image",
      fieldName: "meta_thumbnail_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Thumbnail Image",
    },
    {
      header: "Thumbnail Image Alt Text",
      fieldName: "meta_thumbnail_image_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Thumbnail Image Alt Text",
    },
    {
      header: "Short Course Name",
      fieldName: "meta_short_course_name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Short Course Name (e.g., MBA)",
    },
    {
      header: "Short Course Name Text Color",
      fieldName: "meta_short_course_name_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter short course name text color (e.g., #000000)",
    },
    {
      header: "Full Course Name",
      fieldName: "meta_full_course_name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Full Course Name (e.g., Master of Business Administration)",
    },
    {
      header: "Full Course Name Color",
      fieldName: "meta_course_name_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter full course name color (e.g., #000000)",
    },
    {
      header: "Subtext",
      fieldName: "meta_subtext",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Subtext/Description",
    },
    {
      header: "Subtext Color",
      fieldName: "meta_subtext_color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter subtext color (e.g., #666666)",
    },
    {
      header: "Enroll Icon",
      fieldName: "meta_enroll_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Enroll Icon",
    },
    {
      header: "Enroll Icon Alt Text",
      fieldName: "meta_enroll_icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Enroll Icon Alt Text",
    },
    {
      header: "Enroll Text",
      fieldName: "meta_enroll_text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Enroll Text (e.g., 500+ Enrolled)",
    },
    {
      header: "Enroll Text Color",
      fieldName: "meta_enroll_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter enroll text color (e.g., #000000)",
    },
    {
      header: "Money Icon",
      fieldName: "meta_money_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Money Icon",
    },
    {
      header: "Money Icon Alt Text",
      fieldName: "meta_money_icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Money Icon Alt Text",
    },
    {
      header: "Money Text",
      fieldName: "meta_money_text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Money Text (e.g., ₹5 Lakhs)",
    },
    {
      header: "Money Text Color",
      fieldName: "meta_money_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter money text color (e.g., #000000)",
    },
    {
      header: "Brochure Icon",
      fieldName: "meta_brochure_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Brochure Icon",
    },
    {
      header: "Brochure Icon Alt Text",
      fieldName: "meta_brochure_icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Brochure Icon Alt Text",
    },
    {
      header: "Brochure Text",
      fieldName: "meta_brochure_text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Brochure Text (e.g., Download Brochure)",
    },
    {
      header: "Brochure Text Color",
      fieldName: "meta_brochure_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter brochure text color (e.g., #000000)",
    },
    {
      header: "Brochure Button Border Color",
      fieldName: "meta_brochure_button_background_color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter brochure button Border color (e.g., #ffffff)",
    },
    {
      header: "Enable Brochure",
      fieldName: "meta_enable_brochure",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Brochure Button",
    },
    {
      header: "CTA Button Text",
      fieldName: "meta_cta_button_text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA Button Text (e.g., Apply Now)",
    },
    {
      header: "CTA Button Text Color",
      fieldName: "meta_cta_button_text_color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA button text color (e.g., #ffffff)",
    },
    {
      header: "CTA Button Background Color",
      fieldName: "meta_cta_button_background_color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA button background color (e.g., #BE2330)",
    },
    {
      header: "CTA Button Icon",
      fieldName: "meta_cta_button_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload CTA Button Icon",
    },
    {
      header: "CTA Button Icon Alt Text",
      fieldName: "meta_cta_button_icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA Button Icon Alt Text",
    },
    {
      header: "CTA Mobile Text Color",
      fieldName: "meta_cta_mobile_text_color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA mobile text color (e.g., #ffffff)",
    },
    {
      header: "CTA Mobile Background Color",
      fieldName: "meta_cta_mobile_background_color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA mobile background color (e.g., #BE2330)",
    },
    {
      header: "CTA Mobile Icon",
      fieldName: "meta_cta_mobile_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload CTA Mobile Icon",
    },
    {
      header: "CTA Mobile Icon Alt Text",
      fieldName: "meta_cta_mobile_icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA Mobile Icon Alt Text",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enter Status",
    },
  ]
};

